/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_6_DInputs */

const en_tut_part_6_d = /** @type {(inputs: Tut_Part_6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presence, a deputy that answers while you are away, and a briefing when you return.`)
};

const id_tut_part_6_d = /** @type {(inputs: Tut_Part_6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehadiran, wakil yang menjawab saat Anda pergi, dan ringkasan saat Anda kembali.`)
};

/**
* | output |
* | --- |
* | "Presence, a deputy that answers while you are away, and a briefing when you return." |
*
* @param {Tut_Part_6_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_6_d = /** @type {((inputs?: Tut_Part_6_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_6_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_6_d(inputs)
	return en_tut_part_6_d(inputs)
});